import StoreSocket from '../../../ws/StoreSocket'

/**
 * This function open websocket connection and listen on store and products changes emited by websocket
 * @param storeId
 * @param onProductStockUpdateCallback
 * @param correctCartWhenNotEnoughInStore
 * @param onStoreShippingSettingChanged
 * @param onProductStockSettingChanged
 * @param onStoreStockSettingChanged
 * @param onProductShippingSettingChanged
 */
export function listenOnChanges (
  storeId,
  onProductStockUpdateCallback,
  correctCartWhenNotEnoughInStore,
  onStoreStockSettingChanged,
  onProductStockSettingChanged,
  onStoreShippingSettingChanged,
  onProductShippingSettingChanged
) {
  StoreSocket.enterStore(storeId)
  StoreSocket.onProductStockUpdate(onProductStockUpdateCallback)
  correctCartWhenNotEnoughInStore()
  StoreSocket.onStoreStockSettingChanged(onStoreStockSettingChanged)
  StoreSocket.onProductStockSettingChanged(onProductStockSettingChanged)
  StoreSocket.onStoreShippingSettingChanged(onStoreShippingSettingChanged)
  StoreSocket.onProductShippingSettingChanged(onProductShippingSettingChanged)
}
